<div class="flex justify-end w-full mb-2">
  <div class="w-full lg:w-1/2 md:pl-4 flex">
    <mat-form-field class="w-auto">
      <mat-label>Select a time range</mat-label>
      <mat-select
        [(value)]="selectedTimeRange"
        (selectionChange)="onTimeRangeChange($event)"
      >
        <mat-option [value]="''">No Time Range</mat-option>
        <mat-option value="6hours">Last 6 hours</mat-option>
        <mat-option value="1day">Last 24 hours</mat-option>
        <mat-option value="1month">Last 30 days</mat-option>
        <mat-option value="3months">Last 90 days</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="flex text-white gap-2 md:pl-4 md:gap-4 flex-col lg:flex-row">
  <div
    class="flex flex-col w-full rounded-lg py-2 xl:py-5 px-10 bg-black/10 shadow-inner flex-1"
  >
    <div
      class="flex items-center text-white w-full md:min-w-[210px] justify-center"
    >
      <div class="text-[5rem] font-normal leading-[6rem]">
        @if (isLoading) {
          <div class="loading-spinner">
            <mat-spinner [diameter]="30"></mat-spinner>
          </div>
        } @else {
          {{ ticketTypeCount?.proactive || 0 }}
        }
      </div>
      <div class="text-base font-bold pt-2 leading-6 pl-4 uppercase">
        Proactive
        <span class="font-normal flex leading-[48px] text-[40px] normal-case"
          >Ticket{{ ticketTypeCount?.proactive === 1 ? '' : 's' }}</span
        >
      </div>
    </div>
    <div class="ticket-averages text-center font-normal">
      <div>
        Average Pickup Time:
        <span>{{ proactiveAverageTimeToFirstTouch }}</span>
      </div>
      <div>
        Average Repair Time: <span>{{ proactiveAverageTimeToRepair }}</span>
      </div>
    </div>
  </div>
  <div
    class="flex flex-col w-full rounded-lg py-2 xl:py-5 px-10 bg-black/10 shadow-inner flex-1"
  >
    <div
      class="flex items-center text-white w-full md:min-w-[210px] justify-center"
    >
      <div class="text-[5rem] font-normal leading-[6rem]">
        @if (isLoading) {
          <div class="loading-spinner">
            <mat-spinner [diameter]="30"></mat-spinner>
          </div>
        } @else {
          {{ ticketTypeCount?.nonProactive || 0 }}
        }
      </div>
      <div class="text-base font-bold pt-2 leading-6 pl-4 uppercase">
        Non-Proactive
        <span class="font-normal flex leading-[48px] text-[40px] normal-case">
          Ticket{{ ticketTypeCount?.nonProactive === 1 ? '' : 's' }}
        </span>
      </div>
    </div>
    <div class="ticket-averages text-center font-normal">
      <div>
        Average NOC Pickup Time:
        <span>{{ nonProactiveAverageTimeToFirstTouch }}</span>
      </div>
      <div>
        Average NOC Repair Time:
        <span>{{ nonProactiveAverageTimeToRepair }}</span>
      </div>
    </div>
  </div>
</div>
